import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import withStyles from '../withStyles';
import styles from './MenuDrawerCTA.styles';
export const MenuDrawerCTA = ({ children, classes, }) => _jsx("div", Object.assign({ className: cn(classes.root) }, { children: children }));
export default withStyles(styles)(MenuDrawerCTA);
//# sourceMappingURL=MenuDrawerCTA.js.map